module.exports = __webpack_public_path__ + "static/media/vooom-icon.9aab77dc.png";